import { ApiService } from '../../../ApiService';
import { ApplicationPendingActions } from '../../../../entities/applicant_tracking/analytics/ApplicationPendingActions';

export class ApplicationPendingActionsService {
  public static index(): Promise<ApplicationPendingActions[]> {
    return ApiService.get('/api/applicant_tracking/analytics/pending_actions');
  }
}
